const actionTypeIdentifier = '9C9CCB0A-0AB1-4A4A-B53F-E305E301B152'; //action identifier should be unique

export const getNavItems = `GET_ITEMS-${actionTypeIdentifier}`;
export const setAllSubs = `SET_SUBS_UNDER_LM-${actionTypeIdentifier}`;
export const updateActiveKey = `Update-Active-Key-${actionTypeIdentifier}`;
export const getBurgeMenuUrls = `GET_BURGERMENU_URLS-${actionTypeIdentifier}`;
export const getNewNavItems = `GET_NEW_ITEMS-${actionTypeIdentifier}`;